<template>
  <section id="download" class="download">
    <div class="container">
      <div class="download-card">
        <h2 class="dl-title">开启你的达人连连之旅</h2>
        <p class="dl-sub">选择对应版本下载，安装后配合谷歌浏览器（Chrome）使用</p>

        <div class="dl-actions">
          <button class="btn btn--light" @click="download('normal')">
            <span class="btn-name">会员版下载</span>
            <span class="btn-desc">登录并购买会员使用</span>
          </button>
          <button class="btn btn--outline" @click="download('kami')">
            <span class="btn-name">卡密版下载</span>
            <span class="btn-desc">使用卡密授权激活</span>
          </button>
        </div>

        <p class="dl-note">支持 Windows 系统 · 遇到安装问题可联系在线客服</p>
      </div>
    </div>
  </section>
</template>

<script>
import { downloadLatestApp } from "@/utils/download";

export default {
  name: "DownloadSection",
  methods: {
    download(type) {
      downloadLatestApp(type);
    }
  }
};
</script>

<style scoped>
.download {
  padding: 88px 0;
  background: var(--ink);
}

.download-card {
  max-width: 760px;
  margin: 0 auto;
  text-align: center;
}

.dl-title {
  color: #fff;
  font-size: clamp(26px, 3.4vw, 40px);
  font-weight: 700;
  letter-spacing: -0.02em;
}

.dl-sub {
  margin-top: 14px;
  color: rgba(255, 255, 255, 0.62);
  font-size: 15.5px;
  line-height: 1.7;
}

.dl-actions {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-top: 36px;
}

.btn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  min-width: 200px;
  padding: 14px 22px;
  border-radius: var(--r-lg);
  text-align: left;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease,
    border-color 0.18s ease;
}

.btn:hover {
  transform: translateY(-2px);
}

.btn-name {
  font-size: 16px;
  font-weight: 700;
}

.btn-desc {
  font-size: 12.5px;
  opacity: 0.72;
}

.btn--light {
  background: #fff;
  color: var(--ink);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
}

.btn--light:hover {
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.36);
}

.btn--outline {
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.26);
}

.btn--outline:hover {
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.06);
}

.dl-note {
  margin-top: 24px;
  color: rgba(255, 255, 255, 0.42);
  font-size: 13px;
}

@media (max-width: 640px) {
  .download {
    padding: 56px 0;
  }
  .dl-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    margin-top: 28px;
  }
  .btn {
    align-items: center;
    text-align: center;
    min-width: 0;
  }
}
</style>
